import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _includes from "lodash/includes";
import _filter from "lodash/filter";
import _map from "lodash/map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { resetFeed, getStatementIndexedFeed, removeFeedItemsFromStatementIndexedFeed } from "../actions";

var getInitialState = function getInitialState() {
  return {
    feedItems: [],
    statementIndexedFeedItems: []
  };
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case resetFeed.getType():
      {
        return getInitialState();
      }

    case getStatementIndexedFeed.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          statementIndexedFeedItems: payload
        });
      }

    case removeFeedItemsFromStatementIndexedFeed.getType():
      {
        var ids = payload.ids;

        var filteredStatementIndexedFeedItems = _map(state.statementIndexedFeedItems, function (statementIndexed) {
          return _objectSpread(_objectSpread({}, statementIndexed), {}, {
            cards: _filter(statementIndexed.cards, function (_ref) {
              var id = _ref.id;
              return !_includes(ids, id);
            })
          });
        });

        return _objectSpread(_objectSpread({}, state), {}, {
          statementIndexedFeedItems: filteredStatementIndexedFeedItems
        });
      }

    default:
      return state;
  }
});